<template>
  <div>
    <div v-if="!loading" class="releaseWrapper">
      <div class="backButton">
        <b-button type="is-primary" @click="CloseRelease($router.push('/voiceplus/releases'))" icon-left="arrow-left">Releases</b-button>
      </div>
      <div class="title">Release {{ release.name }}</div>
      <div class="inlineWrapper">
        <div class="typeWrapper box" v-for="type in Types" :key="type">
          <div class="subtitle">{{ type }}(s)</div>
          <div class="contentWrapper">
            <div
              class="item"
              v-for="item in release.tasks.filter((task) => {
                return task.type == type;
              })"
              :key="item.id"
            >
              <a :href="item.url" target="_blank" class="link">{{ item.key }}</a> {{ item.summary }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-loading v-model="loading" is-full-page :can-cancel="false"></b-loading>
  </div>
</template>

<style scoped>
.releasesWrapper {
  display: grid;
  grid-template-columns: 1fr;
  margin: 20px;
}
.release:hover {
  background-color: #efefef;
}
.release {
  display: grid;
  grid-template-columns: 8fr 1fr;
  grid-template-rows: 1fr;
}
.releaseWrapper {
  padding: 20px;
}
.circle {
  width: 30px;
  height: 30px;
  border-radius: 100%;
  box-shadow: 1px 1px 2px 0px black;
}
.red {
  background-color: rgb(255, 55, 55);
}
.blue {
  background-color: rgb(80, 80, 255);
}
.green {
  background-color: rgb(0, 161, 0);
}
.taskWrapper {
  display: grid;
  grid-template-columns: 1fr 5fr;
}
.inlineWrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
}
.typeWrapper.box {
  flex: 1 1 600px;
}
</style>
<script>
const axios = require("axios");
export default {
  components: {},
  data: function () {
    return {
      apiUrl: "https://api.jeak.co.uk",
      loading: true,
      release: {},
      Types: ["Bug", "Improvement", "Task"],
    };
  },
  props: {
    releaseid: {
      type: String,
      required: true,
    },
  },
  methods: {
    OpenRelease: async function () {
      this.loading = true;
      this.viewingReleaseNotes = true;
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: "Bearer " + token },
      };
      axios.get(this.apiUrl + `/releases/${this.releaseid}`, config).then((response) => {
        this.release = response.data;
        this.loading = false;
      });
    },
    CloseRelease: async function () {
      this.viewingReleaseNotes = false;
      this.release = {};
    },
  },
  mounted() {
    this.OpenRelease();
  },
};
</script>
